<!-- Loader -->
<div *ngIf="!isLoaded" class="w-full h-[360px] flex flex-col items-center justify-center gap-4">
  <div class="w-8 h-8 border-4 border-gray-200 border-t-gray-700 rounded-full animate-spin"></div>
  <span class="text-sm font-medium text-gray-400 tracking-wide">
    Followers Growth
  </span>
</div>

<!-- Content -->
<div class="w-full" *ngIf="isLoaded">

  <ng-container *ngIf="metricValue !== null && metricValue > 0; else noData">

    <!-- Header -->
    <div class="mb-4 flex items-start justify-between">
      <h2 class="text-lg font-semibold text-gray-900 tracking-tight">
        Followers Growth
      </h2>
    </div>

    <!-- Chart Card -->
    <div class="relative rounded-2xl border border-gray-200 bg-white shadow-sm p-4">

      <!-- Metric Floating Card -->
      <div class="absolute left-6 top-6 z-10 rounded-xl border border-gray-200 bg-white/95 backdrop-blur px-5 py-3 shadow-sm text-center min-w-[140px]">

        <p class="text-2xl font-semibold text-gray-900 leading-tight">
          {{ metricValue | number }}
        </p>

        <p class="mt-1 flex items-center justify-center gap-1 text-xs font-medium"
          [ngClass]="{
            'text-green-600': metricDiff > 0,
            'text-red-500': metricDiff < 0,
            'text-gray-500': metricDiff === 0
          }"
        >

          <span *ngIf="metricDiff > 0" class="text-sm leading-none">↑</span>
          <span *ngIf="metricDiff < 0" class="text-sm leading-none">↓</span>
          <span *ngIf="metricDiff === 0" class="text-gray-400">–</span>

          {{ metricDiff | number }} vs. start
        </p>

      </div>

      <!-- Chart -->
      <div id="followersChart" class="mt-2">
        <apx-chart
          #chartRef
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [xaxis]="chartOptions.xaxis"
          [yaxis]="chartOptions.yaxis"
          [stroke]="chartOptions.stroke"
          [colors]="chartOptions.colors"
          [dataLabels]="chartOptions.dataLabels"
          class="w-full h-[360px]"
        >
        </apx-chart>
      </div>

    </div>

  </ng-container>

  <!-- No Data -->
  <ng-template #noData>
    <div class="w-full h-[360px] relative flex items-center justify-center rounded-2xl border border-gray-200 bg-white">

      <img
        src="assets/images/charts-not-found.png"
        alt="No data available"
        class="absolute inset-0 w-full h-full object-contain opacity-70 select-none"
      />

      <div class="relative z-10 text-sm font-medium text-gray-400">
        No data available
      </div>

    </div>
  </ng-template>

</div>